import React, {Component} from 'react'

import HeaderSection from '../components/Header/header3';
import HeroSection from '../components/HeroSection/heroSection3';
import PromoSection from '../components/PromoSection/Promo3';
import AboutSection from '../components/AboutUs/AboutUs2';
import VideoSection from '../components/Video';
import ServiceSection from '../components/Service/Service4';
import PricingSection from '../components/Pricing';
import TestimonialSection from '../components/Testimonial';
import ContactSection from '../components/Contact';
import ActionToCallSection from '../components/ActionToCall';
import FooterSection from '../components/footer/footer';


class Theme extends Component{
    render(){
        return(
            <div>
                <HeaderSection />
                <div className="main">
                    <HeroSection />
                    <PromoSection />
                    <AboutSection />
                    <VideoSection />
                    <ServiceSection />
                    <PricingSection />
                    <TestimonialSection />
                    <ContactSection />
                    <ActionToCallSection />
                </div>
                <FooterSection />
            </div>
        )
    }
}

export default Theme;